import { FC } from "react";
import { useIntl } from "react-intl";
import ReactHookDsmSelect from "../../../../../modules/Helpers/ReactHookDsmSelect2";
import { CompoundFeedDatabase, ReportingType } from "../../../../../../graphql/types";
import { getDatabaseOptions } from "../../../CompoundFeedWizard/utils";

interface IBeefFeedDatabaseInfoProps {
  databaseFoundation: string | undefined;
  reportingType: ReportingType | undefined;
}

const BeefFeedDatabaseInfo: FC<IBeefFeedDatabaseInfoProps> = ({
  databaseFoundation,
  reportingType
}) => {
  const intl = useIntl();

  return (
    <ReactHookDsmSelect
      name="databaseFoundation"
      defaultValue={databaseFoundation || CompoundFeedDatabase.Gfli}
      label={`${intl.formatMessage({
        id: "SUSTELL.STAGE.FEED.COMPOUND_FEED.DATABASE_SELETION",
      })}`}
      disabled
      options={getDatabaseOptions(reportingType) as []}
    />
  );
};

export default BeefFeedDatabaseInfo;
